import React, { useContext } from "react";
import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Tooltip,
} from "@mui/material";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { Link, useLocation } from "react-router-dom";
import { LanguageContext } from "./LanguageContext";

const AdministratorMenu = ({ collapsed = false, onItemClick }) => {
    const { translations } = useContext(LanguageContext) || {};
    const { pathname } = useLocation();

    const items = [
        {
            to: "/pocetna",
            icon: <DashboardOutlinedIcon />,
            label: translations?.adminAdministratorMenuHome || "Home",
        },
        {
            to: "/prodavnice",
            icon: <StorefrontOutlinedIcon />,
            label: translations?.adminAdministratorMenuStores || "Stores",
            matches: ["/prodavnica", "/narudzbina"],
        },
        {
            to: "/korisnici",
            icon: <PeopleAltOutlinedIcon />,
            label: translations?.adminAdministratorMenuUsers || "Users",
            matches: ["/korisnik", "/novi-korisnik"],
        },
        {
            to: "/dobavljaci",
            icon: <LocalShippingOutlinedIcon />,
            label: translations?.adminAdministratorMenuSuppliers || "Suppliers",
        },
        {
            to: "/obavestenja",
            icon: <NotificationsOutlinedIcon />,
            label:
                translations?.adminAdministratorMenuNotifications || "Notifications",
        },
    ];

    const isActive = (item) =>
        pathname === item.to ||
        pathname.startsWith(item.to + "/") ||
        (item.matches || []).some((m) => pathname.startsWith(m));

    return (
        <>
            {items.map((item) => {
                const active = isActive(item);
                const button = (
                    <ListItemButton
                        component={Link}
                        to={item.to}
                        onClick={onItemClick}
                        selected={active}
                        sx={{
                            px: collapsed ? 1.25 : 2,
                            py: 1.1,
                            justifyContent: collapsed ? "center" : "flex-start",
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: collapsed ? 0 : 40,
                                justifyContent: "center",
                                color: active ? "primary.main" : "text.secondary",
                            }}
                        >
                            {item.icon}
                        </ListItemIcon>
                        {!collapsed && (
                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{
                                    fontSize: "0.92rem",
                                    fontWeight: active ? 600 : 500,
                                }}
                            />
                        )}
                    </ListItemButton>
                );

                return collapsed ? (
                    <Tooltip key={item.to} title={item.label} placement="right" arrow>
                        {button}
                    </Tooltip>
                ) : (
                    <React.Fragment key={item.to}>{button}</React.Fragment>
                );
            })}
        </>
    );
};

export default AdministratorMenu;